import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { UitkHeading } from 'uitk-react-text';

export interface ListTitleProps {
  title: string;
  className?: string;
}

export const ListTitle = ({ title, className }: ListTitleProps) => {
  if (!title) {
    return null;
  }

  return (
    <ErrorBoundary label="hotel.search.listingTitle">
      <li className={className || 'uitk-cell xl-cell-1-3 l-cell-1-3 m-cell-1-2 s-cell-1-1'}>
        <div className="all-t-padding-three">
          <UitkHeading level={2} size={500}>
            {title}
          </UitkHeading>
        </div>
      </li>
    </ErrorBoundary>
  );
};
